if (!customElements.get('pet-collection')) {
  customElements.define(
    'pet-collection',
    class PetCollection extends HTMLElement {
      connectedCallback() {
        this.strings = JSON.parse(this.querySelector('[data-collection-strings]').textContent);
        this.chips = [...this.querySelectorAll('[data-filter]')];
        this.groups = [...this.querySelectorAll('[data-group]')];
        this.sort = this.querySelector('[data-sort]');
        this.count = this.querySelector('[data-count]');
        this.empty = this.querySelector('[data-empty]');
        this.current = 'all';

        this.chips.forEach((chip) =>
          chip.addEventListener('click', () => {
            this.chips.forEach((other) => other.setAttribute('aria-pressed', String(other === chip)));
            this.current = chip.dataset.filter;
            this.apply();
          })
        );
        if (this.sort) this.sort.addEventListener('change', () => this.apply());
        this.apply();
      }

      matches(card) {
        return this.current === 'all' || card.dataset.tags.split(/\s+/).includes(this.current);
      }

      compare(a, b) {
        const mode = this.sort ? this.sort.value : 'featured';
        if (mode === 'low') return a.dataset.price - b.dataset.price;
        if (mode === 'high') return b.dataset.price - a.dataset.price;
        return a.dataset.order - b.dataset.order;
      }

      apply() {
        let shown = 0;
        this.groups.forEach((group) => {
          const grid = group.querySelector('[data-grid]');
          const cards = [...grid.querySelectorAll('[data-card]')].sort((a, b) => this.compare(a, b));
          cards.forEach((card) => {
            grid.append(card);
            card.hidden = !this.matches(card);
          });
          const visible = cards.filter((card) => !card.hidden);
          cards.forEach((card) => card.classList.remove('pet-card-grid__wide'));
          if (visible.length % 2 === 1) visible[0].classList.add('pet-card-grid__wide');
          group.hidden = visible.length === 0;
          shown += visible.length;
        });
        this.count.textContent = (shown === 1 ? this.strings.one : this.strings.other).replace('[count]', shown);
        this.empty.hidden = shown > 0;
      }
    }
  );
}
